module.exports = __webpack_public_path__ + "img/SS.42d4f582.svg";